var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "user-manage" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("p", [
            _vm._v(
              "今までご利用頂きありがとうございました。ユーザー限定の機能以外は引き続きご利用いただけます。"
            )
          ]),
          _c(
            "router-link",
            { staticClass: "btn btn-primary my-3", attrs: { to: "/" } },
            [_vm._v("トップページに戻る")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pt-2" }, [
      _c("h1", [_vm._v("退会の手続きが完了しました")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }